"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var priceFormatterFactory_1 = require("../../../../../common/service/priceFormatterFactory");
var locale_1 = require("../../../common/service/locale");
exports.default = {
    getFormatter: function (_a) {
        var language = _a.language, country = _a.country, currency = _a.currency, decimalScale = _a.decimalScale, currencyFormatConfig = _a.currencyFormatConfig;
        var currencyLocale = locale_1.default.getCurrencyLocaleCode(language, country, currency);
        var priceArgs = {
            currency: currency,
            style: 'currency',
            currencyDisplay: 'symbol',
            minimumFractionDigits: decimalScale,
            maximumFractionDigits: decimalScale,
        };
        return priceFormatterFactory_1.default.create(priceArgs, currencyLocale, currencyFormatConfig);
    },
};
